import { useMemo } from "react";

import type { MainNavigationMenuItem } from "../types";
import useMainNavigationStore from "../stores/useMainNavigationStore";
import useMainNavigationAllItems from "./useAllMenuItems";

const useMainNavigationPinnedItems = (): MainNavigationMenuItem[] => {
  const { allMenuItemsMap } = useMainNavigationAllItems();
  const pinnedMenuItemIds = useMainNavigationStore((s) => s.pinnedItemIds);

  return useMemo(() => {
    return pinnedMenuItemIds
      .map((itemId) => allMenuItemsMap[itemId])
      .filter((item): item is MainNavigationMenuItem => Boolean(item));
  }, [allMenuItemsMap, pinnedMenuItemIds]);
};

export default useMainNavigationPinnedItems;
